import type { ComponentPropsWithoutRef } from 'react'
import cn from 'classnames'
import styles from './Blocks.module.css'

function FooterBlock({ children, ...attrs }: ComponentPropsWithoutRef<'section'>) {
  return <section {...attrs}>{children}</section>
}

export const Block = FooterBlock

type FooterBlockHeaderProps = ComponentPropsWithoutRef<'h3'>

function FooterBlockHeader({ children, className, ...attrs }: FooterBlockHeaderProps) {
  return (
    <span className={cn(styles.blockHeader, className)} {...attrs}>
      {children}
    </span>
  )
}

export const Header = FooterBlockHeader
